import React from 'react';
import { flaps as tooltip } from 'pu-data/Tooltips';
import RadioDualComponent from './RadioDualComponent';

const StencilFlap = (props) => {
  const name = 'flaps';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <RadioDualComponent
      name={name}
      label="Flaps"
      tooltip={props.tooltip}
      onChange={onChange}
      parameters={props.parameters}
      className={props.className}
      groupName={props.groupName}
      required={props.required}
      labelA="No"
      valueA="0"
      labelB="Yes"
      valueB="1"
      labelClassName="d-block"
      errorMessage={props.errorMessage} />
  );
};

StencilFlap.defaultProps = {
  tooltip,
  className: 'class-3-inspection',
};

export default StencilFlap;
